/**
 * @Copyright 2014-2018 DataVoke, Inc. All rights reserved.
 */

import EventEmitter from "../support/eventemitter";

/**
 * The API object to represent environment variables.
 */
export class VariableApi extends EventEmitter {

    /**
     * Wrap the specified variable object as a new API Variable object.
     * @param {Object} rawVariable - The variable object this API Variable object wraps.
     */
    constructor(rawVariable) {
        super();

        /**
         * Internal reference to the variable object.
         * @type {Object}
         */
        this.raw = rawVariable;

        /**
         * Object that should be used for custom logic to prevent breaking the core API
         * @type {Object}
         */
        this.runtime = {};

        /**
         * Flag to indicate if this object has been disposed.
         * @type {boolean}
         */
        this.isDisposed = false;
    }

    /**
     * Get the value of this variable.
     * @returns {*} The currently stored value of the variable or null if not found.
     */
    getValue () {
        return this.raw && this.raw.InfoValue ? this.raw.InfoValue.Value : null;
    }

    /**
     * Sets this stored variable's value.
     * @param {*} value - The value to store.
     */
    setValue (value) {
        if (this.raw && this.raw.InfoValue) {
            this.raw.InfoValue.Value = value;
        }
    }

    /**
     * Gets the variable's friendly name.
     * @returns {String} The variable's friendly name.
     */
    getFriendlyName () {
        const name = (this.raw && this.raw.FilterString) || '';
        return name.replace(/^{?dvVar_/, "").replace(/^{?dvUserVal_/, "User_").replace(/}$/, "");
    }

    /**
     * Gets the fully qualified variable name from a base name which may or may not already include the standard variable prefix.
     * @returns {String} The fully qualified variable name (e.g. "{dvVar_base.name}").
     */
    getFullName () {
        return (this.raw && this.raw.FilterString) || '';
    }

    /**
     * Internal Use.  Used to assist memory clean-up.
     */
    dispose() {
        if (this.isDisposed) {
            return;
        }
        this.raw = null;
        this.isDisposed = true;
    }
}
